export default {
  BASE_URL: "",
  api: [
    {
      name: "list",
      desc: "获取字典类型",
      method: "GET",
      path: "/pub/dict/list"
    },
    {
      name: "qualificationList",
      desc: "获取企业项目下的关联班组列表",
      method: "GET",
      path: "pc/crm/mem/qualification/list"
    },
    {
      name: "getCategory",
      desc: "工程类别的下拉筛选数据",
      method: "GET",
      path: "/psm/decoration/engin/getCategory"
    },
    {
      name: "getQualityTarget",
      desc: "质量创优目标的下拉筛选",
      method: "GET",
      path: "/psm/decoration/engin/getQualityTarget"
    },
    {
      name: "getBillStatus",
      desc: "申报状态的下拉筛选",
      method: "GET",
      desc: "获取任职分会下拉框",
      method: "GET",
      path: "/pub/dict/chapterIdLabel"
    }
  ]
};



// WEBPACK FOOTER //
// ./src/api/pub/dict/index.js